import { Component, Injector, Input, OnInit } from '@angular/core';
import { WorkplaceActionHandlerBase } from '../../../../../components/common/grid-base/actions/workplace-action-handler-base';
import { TabConfig } from '../../../../../components/common/pollux-tab-config/pollux-form-config';
import { WorkplaceAreaHostBase } from '../../../../../components/common/workplace-area-host-base/workplace-area-host-base';
import { WorkplaceBase } from '../../../../../components/common/workplace-base/workplace-base';
import { ButtonEventForwarderWorkplaceActionHandler } from './actions/button-event-forwarder-workplace-action-handler';
import { CreateTemplateWorkplaceActionHandler } from './actions/create-template-workplace-action-handler';
import { InfobarToggleWorkplaceActionHandler } from './actions/infobar-toggled-workplace-action-handler';
import { ShowLoaderWorkplaceActionHandler } from './actions/show-loader-workplace-action-handler';
import { TabSelectedWorkplaceActionHandler } from './actions/tab-selected-workplace-action-handler';
import { ToggleInfobarWorkplaceActionHandler } from './actions/toggle-infobar-workplace-action-handler';
import { ValuationEventSavedWorkplaceActionHandler } from './actions/valuation-event-saved-workplace-action-handler';
import { AppLoadingIndicatorService } from '../../../../../services/app-loading-indicator.service';

/**
 * Porject Valuation workplace component
 */
@Component({
  selector: 'project-valuation-workplace',
  templateUrl: './project-valuation-workplace.component.html',
  styleUrls: ['./project-valuation-workplace.component.scss']
})
export class ProjectValuationWorkplaceComponent extends WorkplaceBase implements OnInit {
  /**
   * The host component
   */
  private _main: WorkplaceAreaHostBase;

  /**
   * Sets the host component
   */
  @Input() public set main(value: WorkplaceAreaHostBase) {
    this._main = value;
  }

  /**
  * Gets the host component
  */
  public get main(): WorkplaceAreaHostBase {
    return this._main;
  }

  /**
   * Gets the tab config
   */
  public get tabConfig(): TabConfig[] {
    return [
      {
        id: "tabProjectstd",
        searchMode: "projectstd",
        tabIndex: 0,
        tabHierarchy: 0,
        isLeafHierarchy: false,
        enableSearch: true,
        exportAreaName: "Objects"
      },
      {
        id: "tabValuationPortfolio",
        searchMode: "valuationPortfolio",
        tabIndex: 1,
        tabHierarchy: 1,
        isLeafHierarchy: false,
        enableSearch: true,
        exportAreaName: ""
      },
      {
        id: "tabReport",
        searchMode: "report",
        tabIndex: 2,
        tabHierarchy: 2,
        isLeafHierarchy: false,
        enableSearch: true,
        exportAreaName: ""
      },
      {
        id: "tabProperty",
        searchMode: "property",
        tabIndex: 3,
        tabHierarchy: 3,
        isLeafHierarchy: true,
        enableSearch: false,
        exportAreaName: ""
      },
      {
        id: "tabTenant",
        searchMode: "tenant",
        tabIndex: 4,
        tabHierarchy: 4,
        isLeafHierarchy: true,
        enableSearch: false,
        exportAreaName: "ReportRentRoll"
      },
      {
        id: "tabValuation",
        searchMode: "valuation",
        tabIndex: 5,
        tabHierarchy: 5,
        enableSearch: false,
        isLeafHierarchy: true,
        exportAreaName: "ReportValuation"
      }
    ];
  }

  /**
   * Constructor
   * @param injector
   * @param appLoadingIndicator
   */
  constructor(protected injector: Injector, private appLoadingIndicator: AppLoadingIndicatorService) {
    super(injector);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.selectedTab = '#tabProjectstd';
    this.init();
  }

  /**
   * Gets the action handlers used by this workspace area. Implement all logic in these handlers, NOT in the derived class of this class.
   */
  protected get actionHandlers(): WorkplaceActionHandlerBase[] {
    return [
      new TabSelectedWorkplaceActionHandler(this.injector, this),
      new ValuationEventSavedWorkplaceActionHandler(this.injector, this),
      new CreateTemplateWorkplaceActionHandler(this.injector, this),
      new ToggleInfobarWorkplaceActionHandler(this.injector, this),
      new InfobarToggleWorkplaceActionHandler(this.injector, this),
      new ShowLoaderWorkplaceActionHandler(this.injector, this, this.appLoadingIndicator),
      new ButtonEventForwarderWorkplaceActionHandler(this.injector, this, 'buttonNewPortfolioFromProjectStd', 'newPortfolioClickFromProjectStd'),
      new ButtonEventForwarderWorkplaceActionHandler(this.injector, this, 'buttonNewReportFromPortfolioNav', 'createReportsData'),
      new ButtonEventForwarderWorkplaceActionHandler(this.injector, this, 'buttonNewPortfolio', 'newPortfolioClick')
    ];
  }

  /**
   * Registers events
   */
  protected registerEvents(): void {
    //Nothing
  }

  /**
   * Search was clicked
   * @param tab
   */
  public onSearchClicked(tab): void {
    super.onSearchClicked(tab);
    this.eventBus.broadcastEvent("resetValuationSearchMode");
    this.eventBus.broadcastEvent("toolbarSetArea", tab.searchMode);
  }

  /**
   * Sets the counter value
   * @param tab Which tab?
   * @param value
   */
  public setCounterValue(tab, value): void {
    this.eventBus.broadcastEvent("projectvaluation.navigation.handle.state", tab, value);
    super.setCounterValue(tab, value);
  }
}
